module.exports = __webpack_public_path__ + "img/ic_qmarker_greasetrap_lbl.bf374af8.png";